import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). Four fresh dice each apply Poison of
 * their face value to a random target (50/50 enemy/self). */
export const CHAOS_SPREAD: Card = {
  id: 'chaos-spread',
  name: 'Chaos Spread',
  type: 'recursive',
  rarity: 'legendary',
  size: { w: 3, h: 2 },
  cost: [
    { kind: 'min', value: 1 },
    { kind: 'min', value: 1 },
  ],
  effects: [
    {
      kind: 'rollFresh',
      count: 4,
      perFace: [
        {
          facePredicate: { kind: 'min', value: 1 },
          effects: [
            {
              kind: 'applyStatus',
              application: { status: 'poison', magnitude: 0, duration: 1, target: 'opponent' },
              magnitudeFrom: 'faceValue',
              target: 'random',
            },
          ],
        },
      ],
    },
  ],
};
